import React, { useCallback } from 'react';
import { useCounterpartyFilterStore } from '@/stores';
import { MultiSelectDropdown } from '@/components/ui/MultiSelectDropdown';
import { BaseFilterSidebar } from '@/components/ui/BaseFilterSidebar';
import { FrameworkAgreement } from '@/types';

interface FilterSidebarProps {
  filteredDataCount?: number;
  isDataLoading?: boolean;
}

const STATUSES = ['Active', 'Inactive'];
const AGREEMENT_TYPES: FrameworkAgreement[] = ['gmsla', 'gmra'];

export const FilterSidebar: React.FC<FilterSidebarProps> = () => {
  const { filters, setFilters, resetFilters } = useCounterpartyFilterStore();

  const updateFilter = useCallback(
    (key: keyof typeof filters, value: unknown) => {
      setFilters({
        ...filters,
        [key]: value,
      });
    },
    [filters, setFilters]
  );

  const activeFilterCount =
    (filters.statuses.length > 0 ? 1 : 0) +
    (filters.agreementTypes.length > 0 ? 1 : 0);

  return (
    <BaseFilterSidebar
      activeFilterCount={activeFilterCount}
      onClearAll={resetFilters}
    >
      {/* Agreement Type Filter (matches column order) */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-gray-700">Agreement Type</h3>
          {filters.agreementTypes.length > 0 && (
            <button
              onClick={() => updateFilter('agreementTypes', [])}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium"
            >
              Reset
            </button>
          )}
        </div>
        <MultiSelectDropdown
          options={AGREEMENT_TYPES}
          selectedValues={filters.agreementTypes}
          onChange={(values) => updateFilter('agreementTypes', values)}
          placeholder="Select agreement types..."
          searchPlaceholder="Search agreement types..."
          pinSelectedToTop={true}
          showClearAll={false}
        />
      </div>

      {/* Status Filter */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-gray-700">Status</h3>
          {filters.statuses.length > 0 && (
            <button
              onClick={() => updateFilter('statuses', [])}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium"
            >
              Reset
            </button>
          )}
        </div>
        <MultiSelectDropdown
          options={STATUSES}
          selectedValues={filters.statuses}
          onChange={(values) => updateFilter('statuses', values)}
          placeholder="Select statuses..."
          searchPlaceholder="Search statuses..."
          pinSelectedToTop={true}
          showClearAll={false}
        />
      </div>
    </BaseFilterSidebar>
  );
};
